// extracted by mini-css-extract-plugin
export var icon = "_9j-3";
export var subtitle = "_9j-2";
export var title = "_9j-1";
export var value = "_9j-0";